export class ObjectNotFoundError extends Error {
  constructor(message) {
    super(message);
    this.name = "ObjectNotFound";
  }
}
